import Layout from '../../layout'
import { Referrals } from './referrals'

export const ReferralsPage = () => {
  return (
    <Layout>
      <Referrals />
    </Layout>
  )
}
